// 时间处理(时间戳转换为时间)
export const timeProcessing = (val, type) => {
  let time = new Date(val * 1000);
  let year = time.getFullYear();
  let month =
    time.getMonth() + 1 < 10
      ? "0" + (time.getMonth() + 1)
      : time.getMonth() + 1;
  let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
  let HH = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
  let mm = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
  let ss = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
  if (!type) {
    return year + "-" + month + "-" + day;
  } else if (type == 1) {
    return year + "." + month + "." + day + " " + HH + ":" + mm;
  } else if (type == 2) {
    return (
      year + "年" + month + "月" + day + "日" + " " + HH + "时" + mm + "分"
    );
  } else if (type == 3) {
    return year + "年" + month + "月" + day + "日";
  } else if (type == 5) {
    return year + "-" + month + "-" + day + " " + HH + ":" + mm + ":" + ss;
  }
};
// 近一周
export const week = () => {
  var end = new Date();
  var year = end.getFullYear();
  var month = end.getMonth() + 1; //0-11表示1-12月
  var day = end.getDate();
  var dateObj = {};
  dateObj.end = year + "-" + month + "-" + day;
  if (day - 7 <= 0) {
    //如果在当月7日之前
    var startMonthDay = new Date(year, parseInt(month) - 1, 0).getDate(); //1周前所在月的总天数
    if (month - 1 <= 0) {
      //如果在当年的1月份
      dateObj.start = year - 1 + "-" + 12 + "-" + (31 - (7 - day));
    } else {
      dateObj.start =
        year + "-" + (month - 1) + "-" + (startMonthDay - (7 - day));
    }
  } else {
    dateObj.start = year + "-" + month + "-" + (day - 7);
  }
  dateObj = formattingTime(dateObj);
  return dateObj;
};

// 近一月
export const month = () => {
  var end = new Date();
  var year = end.getFullYear();
  var month = end.getMonth() + 1; //0-11表示1-12月
  var day = end.getDate();
  var dateObj = {};
  dateObj.end = year + "-" + month + "-" + day;
  var endMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
  if (month - 1 <= 0) {
    //如果是1月，年数往前推一年<br>
    dateObj.start = year - 1 + "-" + 12 + "-" + day;
  } else {
    var startMonthDay = new Date(year, parseInt(month) - 1, 0).getDate();
    if (startMonthDay < day) {
      //1个月前所在月的总天数小于现在的天日期
      if (day < endMonthDay) {
        //当前天日期小于当前月总天数
        dateObj.start =
          year +
          "-" +
          (month - 1) +
          "-" +
          (startMonthDay - (endMonthDay - day));
      } else {
        dateObj.start = year + "-" + (month - 1) + "-" + startMonthDay;
      }
    } else {
      dateObj.start = year + "-" + (month - 1) + "-" + day;
    }
  }
  dateObj = formattingTime(dateObj);
  return dateObj;
};

// 获取近三个月时间
export const acquire3Time = () => {
  var end = new Date();
  var year = end.getFullYear();
  var month = end.getMonth() + 1; //0-11表示1-12月
  var day = end.getDate();
  var dateObj = {};
  dateObj.end = year + "-" + month + "-" + day;
  var endMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
  if (month - 3 <= 0) {
    //如果是1、2、3月，年数往前推一年
    var start3MonthDay = new Date(
      year - 1,
      12 - (3 - parseInt(month)),
      0
    ).getDate(); //3个月前所在月的总天数
    if (start3MonthDay < day) {
      //3个月前所在月的总天数小于现在的天日期
      dateObj.start =
        year - 1 + "-" + (12 - (3 - month)) + "-" + start3MonthDay;
    } else {
      dateObj.start = year - 1 + "-" + (12 - (3 - month)) + "-" + day;
    }
  } else {
    var start3MonthDay = new Date(year, parseInt(month) - 3, 0).getDate(); //3个月前所在月的总天数
    if (start3MonthDay < day) {
      //3个月前所在月的总天数小于现在的天日期
      if (day < endMonthDay) {
        //当前天日期小于当前月总天数,2月份比较特殊的月份
        dateObj.start =
          year +
          "-" +
          (month - 3) +
          "-" +
          (start3MonthDay - (endMonthDay - day));
      } else {
        dateObj.start = year + "-" + (month - 3) + "-" + start3MonthDay;
      }
    } else {
      dateObj.start = year + "-" + (month - 3) + "-" + day;
    }
  }
  dateObj = formattingTime(dateObj);
  return dateObj;
};

export const formattingTime = (val) => {
  let startTime = new Date(val.start);
  let startYear = startTime.getFullYear();
  let startMonth = startTime.getMonth() + 1 < 10 ? "0" + (startTime.getMonth() + 1)  : startTime.getMonth() + 1;
  let startDay = startTime.getDate() < 10 ? "0" + startTime.getDate() : startTime.getDate();
  let endTime = new Date(val.end);
  let endYear = endTime.getFullYear();
  let endMonth = endTime.getMonth() + 1 < 10 ? "0" + (endTime.getMonth() + 1)  : endTime.getMonth() + 1;
  let endDay = endTime.getDate() < 10 ? "0" + endTime.getDate() : endTime.getDate();
  return {
    start: startYear + "-" + startMonth + "-" + startDay,
    end: endYear + "-" + endMonth + "-" + endDay,
  };
};

// 获取近六个月时间
export const acquire6Time = () => {
  var end = new Date();
  var year = end.getFullYear();
  var month = end.getMonth() + 1; //0-11表示1-12月
  var day = end.getDate();
  var dateObj = {};
  dateObj.end = year + "-" + month + "-" + day;
  var endMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
  if (month - 6 <= 0) {
    //如果是1、2、3、4、5、6月，年数往前推一年
    var start6MonthDay = new Date(
      year - 1,
      12 - (6 - parseInt(month)),
      0
    ).getDate(); //6个月前所在月的总天数
    if (start6MonthDay < day) {
      //6个月前所在月的总天数小于现在的天日期
      dateObj.start =
        year - 1 + "-" + (12 - (6 - month)) + "-" + start6MonthDay;
    } else {
      dateObj.start = year - 1 + "-" + (12 - (6 - month)) + "-" + day;
    }
  } else {
    var start6MonthDay = new Date(year, parseInt(month) - 6, 0).getDate(); //6个月前所在月的总天数
    if (start6MonthDay < day) {
      //6个月前所在月的总天数小于现在的天日期
      if (day < endMonthDay) {
        //当前天日期小于当前月总天数,2月份比较特殊的月份
        dateObj.start =
          year +
          "-" +
          (month - 6) +
          "-" +
          (start6MonthDay - (endMonthDay - day));
      } else {
        dateObj.start = year + "-" + (month - 6) + "-" + start6MonthDay;
      }
    } else {
      dateObj.start = year + "-" + (month - 6) + "-" + day;
    }
  }
  dateObj = formattingTime(dateObj);
  return dateObj;
};
